// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"425":"22c4958e","531":"22c4958e"}[chunkId] + ".chunk.css";
};